import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Submit.css'; // Import styles

const Submit = () => {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        age: '',
        phoneNumber: '',
        homeAddress: '',
        textField: ''
    });

    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({ ...prevState, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        await axios.post('http://localhost:5000/api/forms/submit', formData);
        navigate('/');
    };

    return (
        <div>
            <form onSubmit={handleSubmit}>
                <input type="text" name="firstName" placeholder="First Name" onChange={handleChange} required />
                <input type="text" name="lastName" placeholder="Last Name" onChange={handleChange} required />
                <input type="number" name="age" placeholder="Age" onChange={handleChange} required />
                <input type="tel" name="phoneNumber" placeholder="Phone Number" onChange={handleChange} required />
                <input type="text" name="homeAddress" placeholder="Home Address" onChange={handleChange} required />
                <textarea name="textField" placeholder="Your Text" onChange={handleChange} required></textarea>
                <button type="submit">Submit</button>
            </form>
        </div>
    );
};

export default Submit;
